<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2"  (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                id="111">
                    <h2>पेआउट कैसे बनाएं </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="111">
                    
                    <label for="" class="mt-2">इस गाइड में, हम आपको हमारे प्लेटफ़ॉर्म पर भुगतान शुरू करने की प्रक्रिया के बारे में बताएंगे। चाहे आप अनुभवी उपयोगकर्ता हों या नवागंतुक, ये चरण आपको भुगतान सेटअप को सहजता से नेविगेट करने में मदद करेंगे।  </label>
                </div>
                <div class="col-md-12 mt-3 " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="112">
                    <div class="mt-3">
                        <b>चरण 1:</b> payout.payg.in पर जाएं और अपने खाते में लॉग इन करें। यदि आप पे जी पर नए हैं, तो साइन अप करें और पे जी प्लेटफ़ॉर्म पर ऑनबोर्डिंग प्रक्रिया पूरी करें। 

                    </div>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/cp1.png" width="100%" height="80%" alt="">
                        </div>
                        
                    </div>
                    <div class="col-md-12 mt-2">लॉग इन करने के बाद, एक स्क्रीन दिखाई देगी, जिसमें आपको आवश्यक चरणों का पालन करना होगा।</div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp2.png" width="100%" height="80%" alt="">
                    </div>
                    <div class=" col-md-12 mt-2 ">
                        <b>अपना वर्चुअल खाता बनाएं : </b>  पे जी आपके खाते को सत्यापित करेगा और एक वर्चुअल खाता तैयार करेगा। सत्यापन के बाद, व्यापारी इसमें शेष राशि जोड़ सकते हैं। व्यापारी जितने चाहें उतने खाते बना सकते हैं, और पे जी द्वारा सत्यापित होने के बाद ही वे उनमें एक राशि जोड़ सकते हैं। एक आभासी खाते का स्क्रीनशॉट| 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp3.png" width="50%" height="40%" alt="">
                    </div>
                    <div class="mt-3 ">
                        <b>चरण 2:</b> पे जी द्वारा खाता सत्यापित होने के बाद, पेआउट डैशबोर्ड दिखाए गए अनुसार दिखाई देगा, और वर्चुअल खाता डैशबोर्ड पर पहुंच योग्य होगा। ड्रॉपडाउन मेनू पर क्लिक करके, व्यापारी अधिक खाते जोड़ सकते हैं।   
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp4.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 3:</b>इस चरण का पालन करके और अपने खाते की जानकारी भरकर अपने वर्चुअल खाते में शेष राशि जोड़ें। 

 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp5.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 4:</b> "नई श्रेणी जोड़ें" पर क्लिक करके नई श्रेणियां जोड़ें और श्रेणी का नाम डालें। 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp6.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 5:</b> संपर्कों को लाभार्थियों के रूप में नामित करने के लिए, फंड ट्रांसफर शुरू करने के लिए एक बार "नए संपर्क जोड़ें" पर क्लिक करें। 

  
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp7.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp8.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 6:</b>  अपने लाभार्थियों को धनराशि भेजने के लिए "फंड ट्रांसफर बनाएं" चुनें। 
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp9.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp10.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 7:</b>  व्यापारी "नया उपयोगकर्ता जोड़ें" पर क्लिक करके नए उपयोगकर्ता जोड़ सकते हैं। व्यवस्थापक भूमिकाएँ और अनुमतियाँ बना सकता है, जिससे व्यापारी आवश्यकतानुसार उपयोगकर्ता उत्पन्न कर सकेंगे। 
                    </div><div class="col-md-12 mt-2  ">
                        <img src="./assets/cp11.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp12.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 8:</b> व्यापारी डैशबोर्ड पर अपने लेनदेन को ट्रैक कर सकते हैं और "View Details" पर क्लिक करके विस्तृत जानकारी प्राप्त कर सकते हैं।
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp13.png" width="100%" height="40%" alt="">
                    </div>
                    <div class="mt-3">
                        <b>चरण 9:</b> व्यापारी "Reports" पर क्लिक करके अपने लेनदेन की एक विस्तृत रिपोर्ट तैयार कर सकते हैं और इसे डाउनलोड कर सकते हैं। 
                    </div>Reports
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/cp14.png" width="100%" height="80%" alt="">
                    </div>  
                    
                </div>
                

            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची :
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#111">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> पेआउट कैसे बनाएं </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#112">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    शुरुआत कैसे करें </span>

                            </div>
                        </div>
                    </a>
                </div>
                
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/pay-out']"><button class="btn btn-color" 
                    > <img src="./assets/Arrow 3.svg" alt=""> &nbsp;पेआउट 
                    &nbsp;</button></a> 
               </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/onboarding']">   <button class="btn btn-color" >ऑनबोर्डिंग 
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>